import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { AuthContext } from "../../context/GlobalContextProvider";

/**
 * Atalho para a tela de edição da página, visível só para quem está logado.
 */
export default function EditLink({ to, label = "Editar textos desta página" }) {
  const context = useContext(AuthContext);
  if (!context?.user) return null;
  return (
    <div className="edit-bar">
      <Link className="edit-bar-btn" to={to}>
        ✎ {label}
      </Link>
    </div>
  );
}

EditLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string,
};
